import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import FaqTable from "../../components/datatables/faqs/FaqTable";

const Faq = () => {
  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, []);

  return (
    <Box component={Paper} elevation={0}>
      <Box px={3} py={2}>
        <Typography variant='h4'>Faqs</Typography>
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <FaqTable />
      </Box>
      <Box width={"50%"} mx='auto' my={3} p={3}>
        <Pagination count={10} showFirstButton showLastButton shape='rounded' />
      </Box>
    </Box>
  );
};

export default Faq;
